import { render, staticRenderFns } from "./ProjectTree.vue?vue&type=template&id=f67994a8&"
import script from "./ProjectTree.vue?vue&type=script&lang=js&"
export * from "./ProjectTree.vue?vue&type=script&lang=js&"
import style0 from "./ProjectTree.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports